export default {
      id: "yes-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#yes",
      toString: function () {
        return this.url;
      }
    }